import { RedirectFunction } from '@angular/router';
import { inject } from '@angular/core';
import { NavigationFacade } from '@core/navigation/facades/navigation.facade';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';

export const redirectToFn =
  (topNavigationPath: TopNavigationPath, redirectTo: string): RedirectFunction =>
  () => {
    const navigationFacade = inject(NavigationFacade);

    navigationFacade.setRedirectLeftNavigation(redirectTo);
    navigationFacade.setRedirectTopNavigation(topNavigationPath);

    return redirectTo;
  };
